import React from 'react'
import { NavButton } from '../../../components'
import { useTranslation } from 'react-i18next'

interface SideBarNavProps {
    children: React.ReactNode
}

export const SideBarNav = ({ children }: SideBarNavProps) => {

    const { t } = useTranslation();

    return (
        <nav className="flex flex-col text-white">
            {children}
        </nav>
    )
}